<!--
	Copyright (c) 2021-present, Bäumer, Afonso, Meissner GmbH
	All rights reserved.
-->
<script setup>
import { ref } from "vue";
import { useMouse, useParentElement } from "@vueuse/core";

const parentEl = useParentElement();

const extractor = (event) => {
    return window.TouchEvent && event instanceof Touch
        ? null
        : [event.offsetX, event.offsetY];
};

const { x, y, sourceType } = useMouse({
    touch: false,
    target: parentEl,
    type: extractor,
});
</script>

<template>
    <slot
        v-bind="{
            positionX: x,
            positionY: y,
            positionXRelative: parentEl
                ? (x / parentEl.getBoundingClientRect().width - 0.5) * 2
                : 0,
            positionYRelative: parentEl
                ? (y / parentEl.getBoundingClientRect().height - 0.5) * 2
                : 0,
        }"
    />
</template>
